// import { lazy } from "react";
import { Typography } from "@mui/material";
import PageBox from "../components/layout/pageBox";

export default function DocumentPage({ content }: { content: string }) {

    return <PageBox>
        {
            content === 'privacy' &&
            <Typography color="white" >
                This Privacy Notice explains how Ethism (“we”, “us”, “our”) collects, uses, and protects your information when you use the Ethism platform.

                1. What We Collect
                Wallet and Transaction Data: We collect your wallet address and transaction details when you interact with the platform.

                Usage Data: We may collect device, browser, IP address, and usage analytics.

                Other Data: We may collect additional information if required by law or for platform security.

                2. How We Use Your Data
                To operate and provide the Ethism platform and customer support.

                To process transactions and notify you about activity.

                To detect and prevent fraud or malicious activity.

                To comply with legal obligations.

                To improve and analyze platform performance.

                3. Cookies & Tracking
                We use cookies and similar technologies for essential site functionality and analytics.

                You can control cookies via your browser settings, but disabling them may affect your experience.

                4. Data Sharing
                We do not sell your personal data.

                We may share data with service providers, affiliates, or as required by law.

                We may share data for legal compliance or in the event of a business transaction (e.g., merger or acquisition).

                5. Security
                We use reasonable technical and organizational measures to protect your data.

                No system is 100% secure; use Ethism at your own risk and protect your wallet and devices.

                6. Data Retention
                We retain your data only as long as necessary for platform operation, legal, or regulatory reasons.

                7. Your Rights
                You may request access to, correction of, or deletion of your personal data, subject to legal limitations.

                For requests or questions, contact Ethism support.

                8. Age Restriction
                Ethism is not intended for users under 18. We do not knowingly collect data from minors.

                9. Changes to This Notice
                We may update this Privacy Notice. Continued use of Ethism means you accept the latest version.

                By using Ethism, you acknowledge and accept this Privacy Notice.
                For questions, contact Ethism support.
            </Typography>
        }
        {
            content === 'terms' &&
            <Typography color="white">
                By using the Ethism platform, you agree to these Terms. If you do not agree, do not use Ethism.

                1. Risk Warning
                The value of digital assets can fluctuate significantly. There is a real risk of loss.

                Ethism does not provide investment advice. You are solely responsible for your decisions and any resulting losses.

                2. Eligibility
                You must have the legal right and capacity to use Ethism.

                You may not use Ethism if you are in a jurisdiction where it is prohibited by law or on our list of restricted countries.

                3. Platform Use
                Ethism may refuse, restrict, or terminate your access at any time.

                Do not use Ethism for illegal, abusive, deceptive, or manipulative purposes.

                You must not post or share unlawful, abusive, or misleading content.

                4. Fees
                You agree to pay all applicable fees as displayed during use.

                Fees may change at any time.

                5. Transactions
                All actions on Ethism are at your own risk.

                Ethism does not guarantee the success or speed of any transaction.

                You are responsible for ensuring you have sufficient assets to complete transactions.

                6. Security
                You are responsible for the security of your wallet and devices.

                Notify us immediately if you suspect unauthorized activity.

                7. Privacy
                Your use of Ethism is subject to our Privacy Policy.

                We may process your data as required to provide the service and comply with law.

                8. Intellectual Property
                Ethism and its content are protected by intellectual property laws.

                You may use Ethism only as permitted by these Terms.

                9. Prohibited Use
                You must not:

                Use Ethism for unlawful, fraudulent, or manipulative activities.

                Attempt to hack, disrupt, or reverse-engineer the platform.

                Violate any applicable laws or third-party rights.

                10. Disclaimers & Liability
                Ethism is provided “as is” without warranties.

                Ethism is not liable for losses, delays, or interruptions, unless caused by willful misconduct or fraud.

                You indemnify Ethism against claims arising from your use of the platform.

                11. Changes & Termination
                These Terms may change at any time. Continued use means acceptance of the new Terms.

                Ethism may suspend or terminate your access at its discretion.

                12. Governing Law
                These Terms are governed by the laws of England, unless otherwise required by law.

                13. Contact
                For questions or support, contact us through the official Ethism support channel.

                By using Ethism, you acknowledge and accept these Terms.
            </Typography>
        }
    </PageBox>
}